import React from 'react';
import { Link } from 'react-router-dom';
import { SAMPLE_HREF } from '../lib/links';
interface TryFreeLinkProps {
  size?: 'sm' | 'lg';
  className?: string;
  onClick?: () => void;
}

/** The one primary action on the site: open the free in-browser sample lesson. */
export function TryFreeLink({
  size = 'lg',
  className = '',
  onClick
}: TryFreeLinkProps) {
  const sizing = size === 'lg' ? 'px-7 py-3.5 text-[18px] shadow-chunky' : 'px-4 py-2 text-[16px] shadow-chunky-sm';
  return <Link to={SAMPLE_HREF} onClick={onClick} className={`inline-flex items-center justify-center whitespace-nowrap rounded-2xl border-2 border-ink bg-coral font-display font-semibold text-ink transition-[transform,box-shadow,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-coral-dark active:translate-y-0.5 active:shadow-none ${sizing} ${className}`} data-id="element-311" data-mp="3rd0o9t3ncndr">
      Try Free Adventure
    </Link>;
}